import { BaseService } from "./base";
import type { Patient } from "../../../../../api/src/patient/models/patient.model";

export class PatientListService<T> extends BaseService<T> {
  constructor(path: string) {
    super(path);
  }

  public getPatients({
    id,
  }: {
    id: string;
    }): Promise<{ patients: Patient[]; pendingPatients: Patient[] }> {
    return this.api.get(`/${id}/patients`).then((res) => res.data);
  }

  public isPatientAffiliated({
    id,
    nir,
  }: {
    id: string;
    nir: string;
  }): Promise<{
    exists: boolean;
    affiliated: boolean;
    message?: string;
    patient: Patient;
  }> {
    return this.api
      .get(`/${id}/affiliate-patient`, {
        params: {
          nir,
        },
      })
      .then((res) => res.data);
  }

  public affiliateNewPatient({
    id,
    patient,
  }: {
    id: string;
    patient: Partial<Patient>;
  }) {
    return this.api
      .post(`/${id}/affiliate-patient/new`, patient)
      .then((res) => res.data);
  }

  public affiliatePatient({
    id,
    patientId,
  }: {
    id: string;
    patientId: string;
  }) {
    return this.api
      .post(`/${id}/affiliate-patient/${patientId}`)
      .then((res) => res.data);
  }
}
